export interface CorporatePayPeriodStatsDto {
  corporationId: string;
  corporationName: string;
  periodStartDate: string;
  periodEndDate: string;
  currentPeriodSpending: number;
  currentPeriodInvoiceCount: number;
  currentPeriodContractorCount: number;
  currentPeriodTotalHours: number;
  previousPeriodSpending: number;
  previousPeriodInvoiceCount: number;
  previousPeriodContractorCount: number;
  previousPeriodTotalHours: number;
  spendingChangePercent: number;
  contractorCountChangePercent: number;
  hoursChangePercent: number;
  activeFacilityCount: number;
}
